import React from "react";
import {useLocation} from "react-router-dom";
import PublicLayout from "@components/Layout/Public/PublicLayout";
import PrivateLayout from "@components/Layout/Private/PrivateLayout";
import ProtectedRoute from "@router/ProtectedRoute";
import {useAuthStore} from "@store/AuthStore";
import {AppRoute, RoutePath} from "@router/RoutingModels";

export const ALWAYS_PUBLIC_PATHS = new Set([
    RoutePath[AppRoute.OPS],
    RoutePath[AppRoute.ERROR_404],
    RoutePath[AppRoute.COOKIE_POLICY],
]);

export function normalizePathname(pathname: string) {
    return pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
}

export default function ContextualLayoutRoute() {
    const {isAuthenticated, loading} = useAuthStore();
    const location = useLocation();

    const pathname = normalizePathname(location.pathname);
    const forcePublic = ALWAYS_PUBLIC_PATHS.has(pathname);

    if (forcePublic) return <PublicLayout />;

    if (loading) return null;

    if (isAuthenticated) {
        return (
            <ProtectedRoute>
                <PrivateLayout />
            </ProtectedRoute>
        );
    }

    return <PublicLayout />;
}